<template>
    <div class="container">
        <el-dialog
            title="团队详情"
            :visible.sync="showdialog"
            width="1200px"
            @close="back">
            <div class="team-box">
                <el-row >
                    <el-col class="team-col" :span="16" :offset="0">
                        <div class="warp">
                            <div class="team-cell" v-if="team">
                                <div class="cell-warp">
                                    <p class="text">
                                        <span class="label">名称</span>
                                        <span class="info">{{team.name}}</span>
                                    </p>
                                    <p class="text">
                                        <span class="label">团队类型</span>
                                        <span class="info">{{team.teamtype}}</span>
                                    </p>
                                    <p class="text">
                                        <span class="label">关联楼盘</span>
                                        <span class="info text-success">{{team.projectname}}</span>
                                    </p>
                                    <p class="text" v-if="team.admin">
                                        <span class="label">管理员</span>
                                        <span class="info">{{team.admin.name}}</span>
                                    </p>
                                    <p class="text">
                                        <span class="label">创建时间</span>
                                        <span class="info">{{team.addDate}}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="team-cell">
                                <div class="cell-warp">
                                    <div class="user-cell" v-for="(item, index) in members" :key="index">
                                        <div class="label">
                                            <el-avatar icon="el-icon-user-solid" size="large" shape="circle" :src="item.ltpic" fit="fill"></el-avatar>
                                        </div>
                                        <div class="info">
                                            <span class="textspan">{{item.name}}</span>
                                            <span class="textspan">{{item.company}}</span>
                                            <span class="textspan text-danger" v-if="item.uid==team.admin.uid">管理员</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="team-cell">
                                <div class="btn-box">
                                    <el-button class="btn" type="warning" size="small" v-if="team&&team.putaway==true" @click="setputaway(false)">下架</el-button>
                                    <el-button class="btn" type="success" size="small" v-if="team&&team.putaway==false" @click="setputaway(true)">上架</el-button>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col class="team-col" :span="8" :offset="0"></el-col>
                </el-row>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            showdialog: true,
            id: '',
            team: '',
            members: [],
        }
    },
    mounted () {
        this.id = this.$route.query.id;
        this.getTeamDetail();
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        getTeamDetail() {
            var params = {
                id: this.id,
            };
            this.$api.getTeamconsultantDetailVsId(params).then(
                data=>{
                    // console.log(data);
                    let {team, members} = data;
                    this.team = team;
                    this.members = members;
                }
            )
        },
        setputaway(putaway) {
            var params = {
                id: this.id,
                putaway
            }
            this.$api.teamConsultantPutawayVsId(params).then(
                data=>{
                    this.$message.success(data);
                    this.team.putaway = putaway;
                }
            )
        },
    },
}
</script>

<style lang="scss" scoped>
.team-box{
    overflow: hidden;
    .team-col{
        border-right: 1px solid #ddd;
        padding: 10px;
        background: #f7f7f7;
        box-sizing: border-box;
        &:last-child{
            border-right: none;
        }
        .warp{
            .team-cell{
                background: #fff;
                padding: 10px;
                margin-bottom: 14px;
                &:last-child{
                    margin-bottom: 0;
                }
                .cell-warp{
                    position: relative;
                    overflow: hidden;
                    .text{
                        margin-bottom: 2px;
                        .label{
                            margin-right: 10px;
                            color: #999;
                            width: 80px;
                            text-align: right;
                            display: inline-block;
                        }
                        .info{

                        }
                    }
                    .user-cell{
                        display: flex;
                        .label{
                            
                        }
                        .info{
                            line-height: 40px;
                            margin-left: 10px;
                            .textspan{
                                margin-right: 10px;
                            }
                            
                        }
                        
                    }
                }
                .btn-box{
                    text-align: right;
                    .btn{
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}
</style>